/**
* Created by kongwm.kong on 2017/7/24.
*/
<template>
    <div class="form-page-wrap fund-page-wrap">
        <div class="bread-wrap">
            <div class="layout_n">
                <router-link to="/fund">基金管理</router-link>  >  <span> {{fundType==1 ? '已加入基金' : (fundType==2 ? '待加入基金' : '新增基金')}}</span>
            </div>
        </div>
        <div class="layout_n margin">
            <div class="message_content">
                <div class="process_wrap">
                    <div class="liner">
                        <div :class="{ 'line':true, 'line2': step2, 'line3': step3}"></div>
                    </div>
                    <!--步骤开始-->
                    <div class="step_wrap clearfix" >
                        <div :class="{ 'step': true, 'now': step1 , 'prev': step2||step3}">
                            <div class="step_line">
                                <div :class="{'first': step2||step3 , 'line': true}"></div>
                                <div class="radius_wrap">
                                    <div class="radius">1</div>
                                </div>
                            </div>
                            <div class="text">编辑产品信息</div>
                        </div>
                        <div :class="{ 'step': true, 'now': step2 , 'prev': step3}">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">2</div>
                                </div>
                            </div>
                            <div class="text">信息审核中</div>
                        </div>
                        <div :class="{ 'step': true, 'now': step3 }">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">3</div>
                                </div>
                            </div>
                            <div class="text">信息发布</div>
                        </div>
                    </div>
                </div>
                <div class="item-wrap">
                    <form @submit.prevent="goSubmit">
                        <!--基本信息-->
                        <div class="item">
                            <div class="title"><div class="sub-title">基本信息</div></div>
                            <div class="baseinfo-wrap">
                                <!--一系列表单-->
                                <ul class="clearfix">
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">基金全称</label>
                                            <input type="text" name="prdFullName" :readonly="step2" v-model="baseInfo.prdFullName" @change="getPrdShortName" maxlength="20" v-validate="'required'" placeholder="填写基金全称,不超过20字">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('prdFullName')">{{errors.first('prdFullName')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">基金简称</label>
                                            <input type="text" name="prdShortName" :readonly="step2" v-model="baseInfo.prdShortName"  maxlength="10" v-validate="'required'"  placeholder="填写基金简称,不超过10字">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('prdShortName')">{{errors.first('prdShortName')}}</span>
                                        </div>
                                    </li>
                                    <li v-if="fundId!=0">
                                        <div class="input_wrap">
                                            <label class=" label">基金ID</label>
                                            <input type="text" name="fundDcId" readonly  v-model="baseInfo.fundDcId"  maxlength="10"  placeholder="">
                                        </div>
                                        <div class="err">
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">产品发行类别</label>
                                            <!--<input type="text" name="prdDisCate"  v-model="baseInfo.prdDisCate" v-validate="'required'" placeholder="填写产品发行类别">-->
                                            <div class="select-ul-wrap">
                                                <vue-select :name="'prdDisCate'"  :readonly="step2" :id="baseInfo.fundPrdType" :selectKey="'title'" @closed="closedFundPrdType" v-model="list.fundPrdTypeList[0].title"  @selected="getPrdDisCate" :selectList="list.fundPrdTypeList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.fundPrdTypeFlag">请选择产品发行类别</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">运行状态</label>
                                            <div class="select-ul-wrap">
                                            <vue-select  :name="'simuRiseStatus'" :readonly="step2" :id="baseInfo.simuRiseStatus" @closed="closedSimuRiseStatus"   @selected="getSimuRiseStatus" v-model="list.selectList[0].title" :selectKey="'title'" :selectList="list.selectList"></vue-select>
                                        </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.simuRiseStatusFlag">请选择运行状态</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label :class=" {'label': true, 'required':!required}">募集开始时间</label>
                                            <div class="date-wrap">
                                                 <date-picker class="date-time" :disabled-picker="step2"  language="zh" @closed="closedSimuRiseBeginDate" :format="'yyyy-MM-dd'" v-model="baseInfo.simuRiseBeginDate1" :input-class="'input'"></date-picker>
                                            </div>
                                            <!--<input v-show="step2" v-model="baseMsg.simuRiseBeginDate1" :readonly="step2" >-->
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.simuRiseBeginDateFlag">请选择募集开始时间</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label :class=" {'label': true, 'required':!required}">募集结束时间</label>
                                            <div class="date-wrap" >
                                                 <date-picker class="date-time" :disabled-picker="step2"  language="zh" @closed="closedSimuRiseEndDate" :format="'yyyy-MM-dd'" v-model="baseInfo.simuRiseEndDate1" :input-class="'input'"></date-picker>
                                            </div>
                                            <!--<input v-show="step2" v-model="baseMsg.simuRiseEndDate1" :readonly="step2" >-->
                                        </div>
                                        <div class="err">
                                           <span v-show="!step2 && msg.simuRiseEndDateFlag">请选择募集结束时间</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label :class=" {'label': true, 'required': required1}">备案日期</label>
                                           <div class="date-wrap"  >
                                                 <date-picker class="date-time" :disabled-picker="step2"  language="zh"  name="registerDate" @closed="closedRegisterDate" :format="'yyyy-MM-dd'" v-model="baseInfo.registerDate1" :input-class="'input'"></date-picker>
                                            </div>
                                            <!--<input v-show="step2" v-model="baseMsg.registerDate1" :readonly="step2" >-->
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.registerDateFlag">请选择备案日期</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label :class="{'label': true, 'required':  required1}">备案号码</label>
                                            <input type="text"  name="registerNumber" @blur="asyncPrivateRegisterNumber"  :readonly="step2" v-model="baseMsg.registerNumber" v-validate=" required1 ? 'required|alphaNumber' : 'alphaNumber'" placeholder="填写备案号码，不超过10字">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('registerNumber')">{{errors.first('registerNumber')}}</span>
                                            <span v-show="!step2&&!errors.has('registerNumber') && msg.registerNumberFlag">该备案号已有公司使用，请勿重复录入</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label :class="{'label': true, 'required': required1}">成立日期</label>
                                            <div class="date-wrap"  >
                                                 <date-picker class="date-time" language="zh" @closed="closedSetupDate" :format="'yyyy-MM-dd'" :disabled-picker="step2" v-model="baseInfo.setupDate1" :input-class="'input'"></date-picker>
                                            </div>
                                            <!--<input v-show="step2" v-model="baseMsg.setupDate1" :readonly="step2" >-->
                                        </div>
                                        <div class="err">
                                             <span v-show="!step2 && msg.setupDateFlag">请选择成立日期</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">发行规模（万）</label>
                                            <input type="text" name="issueScale" :readonly="step2"  v-model="baseInfo.issueScale" v-validate="'required|twoPoint'" placeholder="填写发行规模,如：100.00">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('issueScale')">{{errors.first('issueScale')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">投资顾问</label>
                                            <input type="text" name="investConsultant" readonly v-model="prdIssueCompanyName"  placeholder="填写投资顾问">
                                        </div>
                                        <div class="err">
                                            <!--<span v-show="!step2 && errors.has('investConsultant')">{{errors.first('investConsultant')}}</span>-->
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">基金管理人</label>
                                            <div class="instant-wrap">
                                                <vue-instant :suggestion-attribute="'companyFullName'" @blur="blurPrdIssueCompanyCode" @input="getPrdIssueCompanyCode" :show-autocomplete="true" v-model="baseInfo.managementCompanyName"  :disabled="step2" name="managementCompanyName"  @selected="selectedPrdIssueCompanyCode"   placeholder="填写基金管理人" type="google"  :autofocus="false" :suggestions="prdIssueCompanyCodeList" ></vue-instant>
                                            </div>

                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && !msg.prdIssueCompanyCodeFlag">请选择基金管理人</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label ">托管机构名称</label>
                                            <!--<input type="text" maxlength="50" :readonly="step2" name="simuTrustBankName" v-model="baseInfo.simuTrustBankName" v-validate="'required'"  placeholder="填写托管机构名称">-->
                                            <div class="instant-wrap">
                                                <vue-instant :suggestion-attribute="'companyFullName'" @blur="simuTrustBankNameFlag" @input="getSimuTrustBankName" :show-autocomplete="true" v-model="baseInfo.simuTrustBankName"  :disabled="step2" name="simuTrustBankName"  @selected="selectedSimuTrustBankName"   placeholder="选择托管机构名称" type="google"  :autofocus="false" :suggestions="simuTrustBankNameList" ></vue-instant>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && !msg.simuTrustBankNameFlag">请选择托管机构名称</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">单位面值</label>
                                            <input type="text" name="initialUnitValue" :readonly="step2"  v-model="baseInfo.initialUnitValue" v-validate="'required|number'" placeholder="填写单位面值">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('initialUnitValue')">{{errors.first('initialUnitValue')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">存续期</label>
                                            <div class="select-ul-wrap ">
                                                <vue-select  :name="'duration'" :readonly="step2" :id="baseInfo.duration" @selected="getDuration" v-model="list.durationList[0].title" :selectKey="'title'" :placeholder="'选择存续期'"  :selectList="list.durationList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('duration')">{{errors.first('duration')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">起购金额(万)</label>
                                            <input type="text" name="investmentLimit" :readonly="step2" v-model="baseInfo.investmentLimit" v-validate="'required|twoPoint'"  placeholder="填写起购金额，如：100.00">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('investmentLimit')">{{errors.first('investmentLimit')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">追加起点(万)</label>
                                            <input type="text" name="minCapRemark" :readonly="step2" v-model="baseInfo.minCapRemark" v-validate="'required|twoPoint'" placeholder="填写追加起点，如：100.00">
                                        </div>
                                        <div class="err">
                                           <span v-show="!step2 && errors.has('minCapRemark')">{{errors.first('minCapRemark')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">认购费是否内扣</label>
                                            <div class="select-ul-wrap">
                                                <vue-select  :name="'innerBack'" :readonly="step2" :id="baseInfo.innerBack" @closed="closedInnerBack"  @selected="getInnerBack" v-model="list.innerBackList[0].title" :selectKey="'title'" :placeholder="'选择认购费是否内扣'"  :selectList="list.innerBackList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.innerBackFlag">请选择认购费是否内扣</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">净值披露周期</label>
                                            <div class="select-ul-wrap">
                                                <vue-select  :name="'navFrequency'" :readonly="step2" :id="baseInfo.navFrequency" @closed="closedNavFrequency" @selected="getNavFrequency" v-model="list.navFrequencyList[0].title" :selectKey="'title'" :placeholder="'选择净值披露周期'"  :selectList="list.navFrequencyList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.navFrequencyFlag">请选择净值披露周期</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">境内境外</label>
                                            <div class="select-ul-wrap">
                                            <!--<input type="text" name="outsideTerritory" v-model="baseInfo.outsideTerritory" placeholder="填写基金名称，不超过20字">-->
                                                <vue-select  :name="'investmentArea'" :readonly="step2" :id="baseInfo.investmentArea"  @selected="getInvestmentArea" v-model="list.investmentAreaList[0].title" :selectKey="'title'" :placeholder="'选择境内境外'"  :selectList="list.investmentAreaList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">

                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">基础货币</label>
                                            <div class="select-ul-wrap">
                                                <vue-select  :name="'baseCurrency'" :readonly="step2" :id="baseInfo.baseCurrency"  @selected="getBaseCurrency" :value="list.baseCurrencyList[0].title" :selectKey="'title'" :placeholder="'填写基础货币'"  :selectList="list.baseCurrencyList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('baseCurrency')">{{errors.first('baseCurrency')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">清算时间</label>
                                            <div class="date-wrap" >
                                                 <date-picker class="date-time" language="zh" :disabled-picker="step2"  @closed="closedClearingTime" :format="'yyyy-MM-dd'" name="clearingTime" v-model="baseInfo.clearingTime1" :input-class="'input'"></date-picker>
                                            </div>
                                            <!--<input v-show="step2" v-model="baseMsg.clearingTime1" :readonly="step2" >-->
                                        </div>
                                        <div class="err">
                                             <span v-show="!step2 && msg.clearingTimeFlag"></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">清算净值</label>
                                            <input type="text" name="liquidateNetValue" :readonly="step2" v-model="baseInfo.liquidateNetvalue" placeholder="填写清算净值">
                                        </div>
                                        <div class="err">
                                            <span></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">投资策略</label>
                                            <div class="select-ul-wrap">
                                                <vue-select  :name="'simuCelueId'" :readonly="step2" :id="baseInfo.simuCelueId" @closed="closedSimuCelueId" @selected="getSimuCelueId" v-model="msg.simuCelueId" :selectKey="'ptitle'" :placeholder="'选择投资策略'"  :selectList="list.simuCelueIdList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                           <span v-show="!step2 && msg.simuCelueIdFlag">请选择投资策略</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">子策略</label>
                                            <div class="select-ul-wrap">
                                                <vue-select  :name="'substrategy'" :readonly="step2" :id="baseInfo.substrategy" @closed="closedSubstrategy"  @selected="getSubstrategy" v-model="msg.substrategy" :selectKey="'title'" :placeholder="'选择投资策略'"  :selectList="list.substrategyList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.substrategyFlag">请选择子策略</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">认购费率(%)</label>
                                            <input type="text" name="simuFeePurch" :readonly="step2" v-model="baseInfo.simuFeePurch" v-validate="'required|twoPoint'" placeholder="填写认购费率,如：1.23">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('simuFeePurch')">{{errors.first('simuFeePurch')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">管理费率(%)</label>
                                            <input type="text" name="simuFeeFixed"  :readonly="step2" v-model="baseInfo.simuFeeFixed" v-validate="'required|twoPoint'" placeholder="填写管理费率,如：1.23">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('simuFeeFixed')">{{errors.first('simuFeeFixed')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">封闭期(月)</label>
                                            <input type="text" name="simuCloseDate" :readonly="step2" v-model="baseInfo.simuCloseDate" v-validate="'required|number'"  placeholder="填写封闭期">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('simuCloseDate')">{{errors.first('simuCloseDate')}}</span>
                                        </div>
                                    </li>
                                </ul>
                                <!--业绩报酬计提说明-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label">业绩报酬<br>计提说明</label>
                                        <!--<textarea maxlength="50" name="simuOpenDateRemark" v-model="baseInfo.simuOpenDateRemark" placeholder="(非必填)，简要说明开放日说明"></textarea>-->
                                        <!--<div class="num_wrap"><span>0</span>/50</div>-->
                                        <div class="textarea-wrapper">
                                            <vue-textarea :num="50" :readonly="step2"  :name="'performanceFeesExplain'" v-model="baseInfo.performanceFeesExplain" :placeholder="'(非必填)，简要说明业绩报酬计提说明'"></vue-textarea>
                                        </div>
                                    </div>
                                </div>
                                <!--开放日说明-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label">开放日说明</label>
                                        <!--<textarea maxlength="50" name="simuOpenDateRemark" v-model="baseInfo.simuOpenDateRemark" placeholder="(非必填)，简要说明开放日说明"></textarea>-->
                                         <!--<div class="num_wrap"><span>0</span>/50</div>-->
                                        <div class="textarea-wrapper">
                                            <vue-textarea :num="50" :readonly="step2"  :name="'simuOpenDateRemark'" v-model="baseInfo.simuOpenDateRemark" :placeholder="'(非必填)，简要说明开放日说明'"></vue-textarea>
                                        </div>
                                    </div>
                                </div>
                                <!--封闭期说明-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label">封闭期说明</label>
                                        <!--<textarea maxlength="50" name="simuCloseRemark" v-model="baseInfo.simuCloseRemark" placeholder="(非必填)，简要说明封闭期说明"></textarea>-->
                                        <div class="textarea-wrapper">
                                            <vue-textarea :num="50"  :readonly="step2" :name="'simuCloseRemark'" v-model="baseInfo.simuCloseRemark" :placeholder="'(非必填)，简要说明封闭期说明'"></vue-textarea>
                                        </div>
                                    </div>
                                </div>
                                <!--基金经理-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label">基金经理</label>
                                        <div class="fundCom_wrap">
                                            <div class="fund-title">请选择基金经理
                                                <button @click="addManger">+ 添加</button>
                                            </div>
                                            <div class="fund-bd clearfix" v-for="(item , index) in managerList">
                                                <add-manager :item="item" :readonly="step2" :selectKey="'name'" :totalLen="managerList.length" @deleteManager="deleteManager" @selectedMan="selectedMan" :selectList="manSelectList" :index="index"></add-manager>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--两个输入框-->
                                <ul class="clearfix">
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">预警线</label>
                                            <input type="text" name="alertLine" :readonly="step2" v-model="baseInfo.alertLine" v-validate="'fourthPoint'"  placeholder="填写预警线,如： 1.0000">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('alertLine')">{{errors.first('alertLine')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">止损线</label>
                                            <input type="text" name="stopLine" :readonly="step2" v-model="baseInfo.stopLine"  v-validate="'fourthPoint'" placeholder="填写止损线,如： 1.0000">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('stopLine')">{{errors.first('stopLine')}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--更多说明-->
                        <div class="item">
                            <div class="title"><div class="sub-title">更多说明</div></div>
                            <div class="baseinfo-wrap">
                                <!--开放日说明-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label required">投资范围</label>
                                        <div class="textarea-wrapper">
                                            <vue-textarea :num="500" ref="investmentScope"  @errorsChanged="investmentScopeError"  :readonly="step2" :validate="'required'" :name="'investmentScope'" v-model="baseInfo.investmentScope" :placeholder="'(必填)，说明投资范围'"></vue-textarea>
                                        </div>
                                    </div>
                                </div>
                                <!--两个输入框-->
                                <ul class="clearfix">
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">赎回费率(%)</label>
                                            <input type="text" :readonly="step2" v-model="baseInfo.simuFeeRedem" v-validate="'required|twoPoint'" name="simuFeeRedem" placeholder="填写赎回费率,如：1.23">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('simuFeeRedem')">{{errors.first('simuFeeRedem')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label label1">赎回提前申请时间</label>
                                            <input type="text" :readonly="step2" v-model="baseInfo.redemptionAdvancedNoticeTime"  v-validate="'number'" name="redemptionAdvancedNoticeTime" placeholder="填写赎回提前申请时间">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('redemptionAdvancedNoticeTime')">{{errors.first('redemptionAdvancedNoticeTime')}}</span>
                                        </div>
                                    </li>
                                </ul>
                                <!--贴回费说明-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label">赎回费说明</label>
                                        <div class="textarea-wrapper">
                                            <vue-textarea :num="50" :readonly="step2" :name="'redemptionFeeNote'" v-model="baseInfo.redemptionFeeNote" :placeholder="'(非必填)，简要说明赎回费'"></vue-textarea>
                                        </div>
                                    </div>

                                </div>
                                <!--分红说明-->
                                <!--<div class="input-item">-->
                                    <!--<div class="item-main">-->
                                        <!--<label class="label">分红说明</label>-->
                                        <!--<div class="textarea-wrapper">-->
                                            <!--<vue-textarea :num="50" :readonly="step2"  :name="'bonus'" v-model="baseInfo.bonus" :placeholder="'(非必填)，简要说明分红说明'"></vue-textarea>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                                <!--双行-->
                                <ul class="clearfix">
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">业绩报酬<br>
                                                计提比例(%)</label>
                                            <input type="text" :readonly="step2" name="performanceFeesProportion" v-model="baseInfo.performanceFeesProportion" v-validate="'required|twoPoint'" placeholder="填写业绩报酬计提比例">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && errors.has('performanceFeesProportion')">{{errors.first('performanceFeesProportion')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">业绩报酬<br>计提形式</label>
                                            <!--<input type="text" name="performanceFeesForm" placeholder="填写业绩报酬计提形式">-->
                                            <div class="select-ul-wrap">
                                                <vue-select  :readonly="step2" :name="'performanceFeesForm'" :id="baseInfo.performanceFeesForm"  @selected="getPerformanceFeesForm" v-model="msg.performanceFeesForm" :selectKey="'title'" :placeholder="'选择业绩报酬计提形式'"  :selectList="list.performanceFeesFormList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--提交按钮-->
                        <div class="btn-commit-wrap" v-show="!step2">
                            <button class="btn-bg-def commit btn" type="submit">提交</button>
                            <button class="btn-def save  btn" @click="goToSave">保存暂不提交</button>
                        </div>
                        <p class="ps-hot">温馨提示：审核期间不可编辑基金信息</p>
                        <div class="err" style="text-align: center">{{msgErrText}}</div>
                    </form>
                </div>
            </div>
        </div>
        <submit-ok :isSave="isSave" @closeModal="golist"></submit-ok>
    </div>
</template>
<script>
//    import datePicker from 'vuejs-datepicker';
    import datePicker from '../../components/middleware/Datepicker';
    import vueSelect from '../../components/form/select';
    import vueTextarea from '../../components/form/textarea.vue';
    import formList from '../../assets/js/formList';
    import addManager from '../../components/form/addManager';
    import tool from '../../assets/js/common/tool';
    import submitOk from '../../components/modal/submitOk'
    export default {
        components:{
            datePicker,
            vueSelect,
            vueTextarea,
            addManager,
            submitOk
        },
        watch: {
            $route(){
                this.getFundDetail();
            }
        },
        created(){
            this.$store.commit('getLoginInfo');
        },
        mounted(){
            this.getFundDetail();
            this.isRequired();
        },
        data (){
            return {
                required: true,
                required1: true,
                isSave: false,
                msgErrText: '',
                prdIssueCompanyCodeList: [],
                simuTrustBankNameList: [],
                step1: true,
                step2: false,
                step3: false,
                list: formList,
                fundId: 0,
                fundType: 1,
                manaList: [],
                managerList:[{'name': null, fundDcId: null, readonly: false, managementStartDate:'', managementEndDate:'', id:null}],
                manSelectList:[],
                baseInfo:{
                    fundDcId: null,
                    performanceFeesExplain: null,
                    prdFullName: null, //基金全称
                    prdShortName:null, // 基金简称
                    performanceFeesProportion: null, //业绩报酬
                    simuTrustBankName:'',
                    simuRiseStatus: formList.selectList[0].id,
                    duration: formList.durationList[0].id,
                    innerBack: formList.innerBackList[0].id,
                    navFrequency: formList.navFrequencyList[0].id,
                    baseCurrency: formList.baseCurrencyList[0].id,
                    simuCelueId: formList.simuCelueIdList[0].id,
                    prdDisCate: null, //产品发行类别
                    simuRiseBeginDate1: null,
                    simuRiseEndDate1:null,
                    registerDate1: null,
                    registerNumber: null,
                    setupDate1: null,
                    issueScale:null,
                    managementCompanyCode: null,
                    managementCompanyName: '',
                    initialUnitValue: null,
                    investmentLimit: null,
                    minCapRemark: null,
                    outsideTerritory: null,
                    clearingTime1: null,
                    liquidateNetvalue: null,
                    simuFeePurch: null,
                    simuFeeFixed: null,
                    simuCloseDate: null,
                    simuOpenDateRemark: null,
                    simuCloseRemark: null,
                    alertLine: null,
                    stopLine: null,
                    investmentScope: null,
                    simuFeeRedem: null,
                    redemptionAdvancedNoticeTime: null,
                    redemptionFeeNote: null,
//                    bonus: null,
                    substrategy: formList.substrategyList[0].id,
                    performanceFeesForm: formList.performanceFeesFormList[0].id,
                    investmentArea: formList.investmentAreaList[0].id,
                    fundPrdType: formList.fundPrdTypeList[0].id
                },
                msg:{
                    simuCelueId: formList.simuCelueIdList[0].ptitle,
                    substrategy: formList.substrategyList[0].title,
                    performanceFeesForm: formList.performanceFeesFormList[0].title,
                    registerDateFlag: false,
                    setupDateFlag: false,
                    registerNumberFlag: false,
                    prdIssueCompanyCodeFlag:true,
                    prdIssueCompanyCode: '',
                    simuTrustBankName: '',
                    simuTrustBankNameFlag : true,
                    simuRiseEndDateFlag: false,
                    simuRiseStartDateFlag: false,
                    simuRiseBeginDateFlag: false,
                    investmentScopeFlag: false,
                    simuRiseStatusFlag: false,/*运行状态*/
                    navFrequencyFlag: false, /*净值披露周期*/
                    fundPrdTypeFlag: false, /*产品发行类别*/
                    substrategyFlag: false, /*投资子策略*/
                    simuCelueIdFlag: false, /*投资策略*/
                    innerBackFlag: false, /*认购费是否内扣*/

                },
                baseMsg:{
                    simuRiseBeginDate1: null,
                    simuRiseEndDate1: null,
                    registerDate1: null,
                    setupDate1: null,
                    registerNumber: null,
                    clearingTime1: null
                },
                suggestions:[],
                suggestionAttribute: 'title'
            }
        },
        computed:{
            prdIssueCompanyName(){
                let userData = this.$store.state.userData;
                if(userData !=null && userData.companyName){
                    return userData.companyName;
                } else {
                    return null;
                }
            },
            /*所有下拉框的是否可以提交*/
            allSeleFlag(){
                return !this.msg.simuRiseStatusFlag && !this.msg.navFrequencyFlag && !this.msg.fundPrdTypeFlag && !this.msg.substrategyFlag
                    &&!this.msg.simuCelueIdFlag && !this.msg.innerBackFlag ;
            }
        },
        methods:{
            getManagerList(){
                this.$http.request({
                    url: `/manager/list/sample`
                }, response => {
                    if(response.data.code == 200){
                        this.manaList = response.data.data;
                        this.manSelectList = this.manaList;   // 将获取的到所有的值，复赋值给页面可供选择的
                        this.getList();
                        this.deleteSame();
                    }
                },err => {
                })
            },
            /*获取数据*/
            getFundDetail(){
                this.fundId = this.$route.params.id;
                this.fundType = this.$route.params.type; // 1 已加入  2  待加入
                if(this.fundId == 0){ //编辑  第一步
                    this.setStep(1);
                    this.getManagerList();
                } else if(this.fundType !=0){
                    if(this.fundType == 1){
                        this.setStep(3);
                    } else if(this.fundType == 2){
                        this.setStep(1);
                    }
                    let url = this.fundType==1 ? `/product/result/fundDcId_${this.fundId}/detail`: `/product/report/id_${this.fundId}/detail`;
                    this.$http.request({
                        url: url
                    }, response => {
                        if(response.data.code == 200){
                            this.baseInfo = response.data.data;
                            if(this.fundType==2 && this.baseInfo.auditStatus ==0){ // 待审核
                                this.setStep(2);
                            }
                            this.getManagerList();
                            this.initFundData();
                            this.getSubstaryList(); /*获取子策略*/
                            this.isRequired();  //判断运行状态的必填与非必填
                            this.getSubstaryList();
                        }
                    },err => {

                    })
                }
            },
            setStep(step){
                this.step1 = false;
                this.step2 = false;
                this.step3 = false;
                this['step'+step] = true;
            },
            /*初始化数据*/
            initFundData(){
                this.baseInfo.simuRiseBeginDate1 = tool.numToDate(this.baseInfo.simuRiseBeginDate);
                this.baseInfo.simuRiseEndDate1 = tool.numToDate(this.baseInfo.simuRiseEndDate);
                this.baseInfo.registerDate1 = tool.numToDate(this.baseInfo.registerDate);
                this.baseInfo.setupDate1 = tool.numToDate(this.baseInfo.setupDate);
                this.baseInfo.clearingTime1 = tool.numToDate(this.baseInfo.clearingTime);
                this.baseInfo.investmentLimit = tool.toFixed1(this.baseInfo.investmentLimit, 2);
                this.baseInfo.minCapRemark = tool.toFixed1(this.baseInfo.minCapRemark, 2);
                this.baseInfo.simuFeePurch = tool.toFixed1(this.baseInfo.simuFeePurch, 2);
                this.baseInfo.simuFeeFixed = tool.toFixed1(this.baseInfo.simuFeeFixed, 2);
                this.baseInfo.alertLine = tool.toFixed1(this.baseInfo.alertLine, 4);
                this.baseInfo.stopLine = tool.toFixed1(this.baseInfo.stopLine, 4);
                this.baseInfo.simuFeeRedem = tool.toFixed1(this.baseInfo.simuFeeRedem, 2);
                this.baseInfo.issueScale = tool.toFixed1(this.baseInfo.issueScale, 2);
                this.initTimeData();
            },
            initTimeData(){
                this.baseMsg.registerNumber = this.baseInfo.registerNumber;
                this.baseMsg.setupDate1 = tool.transformTime(this.baseInfo.setupDate, 'yyyy-mm-dd');

                this.baseMsg.simuRiseBeginDate1 = tool.transformTime(this.baseInfo.simuRiseBeginDate, 'yyyy-mm-dd');

                this.baseMsg.simuRiseEndDate1 = tool.transformTime(this.baseInfo.simuRiseEndDate, 'yyyy-mm-dd');

                this.baseMsg.registerDate1 = tool.transformTime(this.baseInfo.registerDate, 'yyyy-mm-dd');

                this.baseMsg.clearingTime1 = tool.transformTime(this.baseInfo.clearingTime, 'yyyy-mm-dd');
            },
            /*获取子策略list*/
            getSubstaryList(){
                this.list.substrategyList = formList.substrategyList;
                /*if(typeof this.baseInfo.simuCelueId === 'number'){
                    for(let i=0; i< formList.simuCelueIdList.length; i++){
                        if(this.baseInfo.simuCelueId === formList.simuCelueIdList[i].id ){
                            this.list.substrategyList = formList.simuCelueIdList[i].sublist;
                        }
                    }
                }*/
            },
            /*获取经理列表*/
            getList(){
                let list = [];
                if(this.baseInfo.managers.length){
                    let managerList = this.baseInfo.managers;   // 后端传回来的值  付给在页面模拟的值
                    if(this.manaList.length){  // 总的经理列表
                        for(let i =0; i<managerList.length; i++){
                            for(let j =0; j<this.manaList.length; j++ ){
                                if(managerList[i].managerCode === this.manaList[j].fundDcId){
                                    if( (managerList[i].fundDcId != null &&managerList[i].fundDcId) || this.step2){
                                        managerList[i].readonly = true;
                                        managerList[i].isDelete = true;  //从后台传进来的  不能删除
                                    }
                                    managerList[i].name = this.manaList[j].name;
                                    managerList[i].managementEndDate = tool.numToDate(managerList[i].managementEndDate);
                                    managerList[i].managementStartDate = tool.numToDate(managerList[i].managementStartDate);
                                    list.push(managerList[i]);
                                }
                            }
                        }
                    }
                }
                if(list.length){
                    this.managerList = list;
                }
            },
            /*删除相同的名字*/
            deleteSame(){  // 给出供选择列表
                let list = [], obj={};
                for(let i =0; i<this.managerList.length; i++){
                    obj[this.managerList[i].managerCode]  = true;
                }
                for(let k =0; k<this.manaList.length; k++ ){
                    if(!obj[this.manaList[k].fundDcId]){
                        obj[this.manaList[k].fundDcId] = true;
                        list.push(this.manaList[k]);
                    }
                }
                this.manSelectList = list;
            },
            /*提交之前数据转换*/
            beforeCommit(){
                if(this.step3){
                    this.$delete(this.baseInfo ,'id');
                }
                this.baseInfo.prdIssueCompanyName = this.prdIssueCompanyName;
//                this.baseInfo.simuTrustBankName =  this.msg.simuTrustBankName;
                this.baseInfo.registerNumber = this.baseMsg.registerNumber;
                this.baseInfo.simuRiseBeginDate = tool.dateToNum(this.baseInfo.simuRiseBeginDate1); //募集开始时间
                this.baseInfo.simuRiseEndDate = tool.dateToNum(this.baseInfo.simuRiseEndDate1); //募集结束时间
                this.baseInfo.registerDate = tool.dateToNum(this.baseInfo.registerDate1); //募集结束时间
                this.baseInfo.setupDate = tool.dateToNum(this.baseInfo.setupDate1); //成立日期
                this.baseInfo.clearingTime = tool.dateToNum(this.baseInfo.clearingTime1); //清算时间
                this.baseInfo.managers = [];
                if(this.managerList.length && this.managerList[0].name !== null && !!this.managerList[0].name ){
                    let len = this.managerList.length;
                    if(this.managerList[len-1].name === '' ||  this.managerList[len-1].name === null){
                        let arr = JSON.parse(JSON.stringify(this.managerList.slice(0, len-1)));
                        this.getManagerListTime(arr);
                    } else {
                        let arr = JSON.parse(JSON.stringify(this.managerList));
                        this.getManagerListTime(arr);
//                        this.baseInfo.managers = this.managerList;
                    }
                }
            },
            getManagerListTime(arr){   //
                if(arr.length){
                    arr.forEach((el, index, array)=>{
                        el.managementEndDate = tool.dateToNum(el.managementEndDate);
                        el.managementStartDate = tool.dateToNum(el.managementStartDate);
                    });
                    this.baseInfo.managers = arr;
                }
            },
            /*模糊搜索*/
            changed(obj){

            },
            /**/
            getPrdShortName(e){
                let fullName = this.baseInfo.prdFullName;
                const  KEEP_WORD = "私募基金宝";
                let splits = fullName.split(KEEP_WORD);
                const FILTER_REGEXP = /证券投资基金|资管计划|资金信托计划|集合计划|股权投资管理|资产管理计划|私募投资基金|私募基金|特定多个客户|单一客户|资产管理计划|投资基金|证券投资集合资金信托计划|私募证券投资基金|集合资金信托计划|集合资产管理计划|资金信托计划|多个客户|基金精选资产管理计划|特定资产管理计划|特定多客户资产管理计划|特定（多个）客户资产管理计划|信托单元|资产管理合同|管理合同|特定客户资产管理计划|项目资产管理计划/g;
                splits.forEach(function (date, n){
                    splits[n] = date.replace(FILTER_REGEXP, '');
                });
                this.baseInfo.prdShortName = splits.join(KEEP_WORD);
                this.$validator.validate('prdShortName', this.baseInfo.prdShortName);
            },
            /*自己判断的部分*/
            getErrFlag(){
                this.closedRegisterDate();
                this.closedSetupDate();
                this.prdIssueCompanyCodeFlag();
                this.closedSimuRiseBeginDate();
                this.closedSimuRiseEndDate();
                this.closedSimuRiseStatus();/*运行状态*/
                this.closedInnerBack();/*认购费是否内扣*/
                this.closedNavFrequency();/*净值披露周期*/
                this.closedSimuCelueId();/*投资策略*/
                this.closedSubstrategy();/*投资子策略*/
                this.closedFundPrdType(); /*产品发行类别*/

            },
            /*基金管理人*/
            prdIssueCompanyCodeFlag(){
                if(this.baseInfo.managementCompanyName === null || this.baseInfo.managementCompanyName===''){
                    this.msg.prdIssueCompanyCodeFlag = false;
                } else if(this.baseInfo.managementCompanyCode === null ){
                    this.msg.prdIssueCompanyCodeFlag = false;
                } else {
                    this.msg.prdIssueCompanyCodeFlag = true;
                }
            },
            //基金管理人选择
            blurPrdIssueCompanyCode(){
                this.prdIssueCompanyCodeFlag();
            },
            //基金管理人选择
            getPrdIssueCompanyCode(){
                if(this.baseInfo.managementCompanyName === null || this.baseInfo.managementCompanyName === '' ){
                    return false;
                }
                this.prdIssueCompanyCodeList = [];
                this.baseInfo.managementCompanyCode = null;
                this.getCompanyList(this.baseInfo.managementCompanyName, 'prdIssueCompanyCode');
            },
            //基金管理人选择
            selectedPrdIssueCompanyCode(obj){
                if(obj == null ){ return false;}
                this.baseInfo.managementCompanyName = obj.companyFullName;
                this.baseInfo.managementCompanyCode = obj.fundDcId;
                this.msg.prdIssueCompanyCodeFlag = true;
            },

            getCompanyList(msg, flag){
                if(!msg){
                    return false;
                }
                msg = encodeURIComponent(msg);
                setTimeout(()=>{
                    this.$http.request({
                        url: `/company/list/sample?key=${msg}`
                    }, res => {
                        if(res.data.code === 200 && res.data.data){
                            if(flag === 'prdIssueCompanyCode'){
                                this.prdIssueCompanyCodeList = res.data.data;
                            } else if(flag === 'simuTrustBankName'){
                                this.simuTrustBankNameList = res.data.data;
                            }
                        }
                    }, err => {

                    });
                }, 500);
            },
            simuTrustBankNameFlag(){
                if(this.baseInfo.simuTrustBankName == null || this.baseInfo.simuTrustBankName == ''  ){
                    this.msg.simuTrustBankNameFlag = true;
                } else if(this.baseInfo.simuBankCode == null){
                    this.msg.simuTrustBankNameFlag = false;
                } else {
                    this.msg.simuTrustBankNameFlag = true;
                }
            },
            /*托管机构名称*/
            selectedSimuTrustBankName(obj){
                this.baseInfo.simuTrustBankName = obj.companyFullName;
                this.baseInfo.simuBankCode = obj.fundDcId;
                this.msg.simuTrustBankNameFlag = true;
            },
            getSimuTrustBankName(){
//                console.log(this.baseInfo.simuTrustBankName);
                if(this.baseInfo.simuTrustBankName == null || this.baseInfo.simuTrustBankName == ''){
                    return false;
                }
                this.simuTrustBankNameList = [];
                this.baseInfo.simuBankCode = null;
                this.getCompanyList(this.baseInfo.simuTrustBankName, 'simuTrustBankName');
            },
            /*动态验证备案号码*/
            asyncPrivateRegisterNumber(){
                this.msg.registerNumberFlag = false;
                if(this.baseMsg.registerNumber != this.baseInfo.registerNumber && !this.errors.has('registerNumber')){
                    this.$http.request({
                        url: `/product/checkRegisterNumber?registerNumber=${this.baseMsg.registerNumber}`
                    }, res => {
                        if(res.data.code === 200 ){
                            this.msg.registerNumberFlag = !res.data.data;
                        } else {
                            this.msg.registerNumberFlag = true;
                        }
                    }, err => {
                        this.msg.registerNumberFlag = true;
                    });
                }
            },
            /*募集开始时间*/
            closedSimuRiseBeginDate(){
                if((this.baseInfo.simuRiseBeginDate1 == null || this.baseInfo.simuRiseBeginDate1== '')&& !this.required) {
                    this.msg.simuRiseBeginDateFlag = true;
                } else {
                    this.msg.simuRiseBeginDateFlag = false;
                }
            },
            /*募集结束时间*/
            closedSimuRiseEndDate(){
                if((this.baseInfo.simuRiseEndDate1 == null || this.baseInfo.simuRiseEndDate1== '') && !this.required){
                    this.msg.simuRiseEndDateFlag = true;
                }  else {
                    this.msg.simuRiseEndDateFlag = false;
                }
            },
            /*备案日期*/
            closedRegisterDate(){
                if(this.baseInfo.registerDate1 && this.baseInfo.registerDate1 != null){
                    this.msg.registerDateFlag =  false;
                } else if(!this.required1){
                    this.msg.registerDateFlag =  false;
                } else {
                    this.msg.registerDateFlag = true;
                }
            },
            /*成立日期*/
            closedSetupDate(){
                if(this.baseInfo.setupDate1 && this.baseInfo.setupDate1 != null){
                    this.msg.setupDateFlag =  false;
                }  else if(!this.required1){
                    this.msg.setupDateFlag =  false;
                } else {
                    this.msg.setupDateFlag = true;
                }
//                this.baseInfo.setupDate = tool.dateToNum(this.baseInfo.setupDate1);
            },
            /*清算时间*/
            closedClearingTime(){
//                this.baseInfo.clearingTime = tool.dateToNum(this.baseInfo.clearingTime1);
            },
            /*机构管理名称*/
            selected(obj){
                this.baseInfo.simuTrustBankName = obj.id;
            },
            /*更改是否必填*/
            isRequired(){
                if(this.baseInfo.simuRiseStatus == 4 ||this.baseInfo.simuRiseStatus == 5 ||this.baseInfo.simuRiseStatus == 6){
                    this.required1 = false;
                    this.msg.registerDateFlag = false;
                    this.msg.setupDateFlag = false;
                } else {
                    this.required1 = true;
                }
                if(this.baseInfo.simuRiseStatus === 1){
                    this.required = false;
                    this.required1 = false;
                    this.msg.simuRiseEndDateFlag = false;
                    this.msg.simuRiseBeginDateFlag = false;
                    this.msg.registerDateFlag = false;
                    this.msg.setupDateFlag = false;

                } else {
                    this.required = true;
                }
            },
            /*运行状态*/
            getSimuRiseStatus(obj){
                this.baseInfo.simuRiseStatus = obj.id;
                this.isRequired();
            },
            closedSimuRiseStatus(){
                if(typeof this.baseInfo.simuRiseStatus != "number" ){
                    this.msg.simuRiseStatusFlag = true;
                } else {
                    this.msg.simuRiseStatusFlag = false;
                }
            },
            /*续存期*/
            getDuration(obj){
                this.baseInfo.duration = obj.id;
//                console.log(this.baseInfo.duration);
            },
            /*认购费是否内扣*/
            getInnerBack(obj){
                this.baseInfo.innerBack = obj.id;
            },
            closedInnerBack(){
                if(typeof this.baseInfo.innerBack != "number" ){
                    this.msg.innerBackFlag = true;
                } else {
                    this.msg.innerBackFlag = false;
                }
            },
            /*净值披露周期*/
            getNavFrequency(obj){
                this.baseInfo.navFrequency = obj.id;
            },
            closedNavFrequency(){
                if(typeof this.baseInfo.navFrequency != "number" ){
                    this.msg.navFrequencyFlag = true;
                } else {
                    this.msg.navFrequencyFlag = false;
                }
            },
            /*境外境内*/
            getInvestmentArea(obj){
                this.baseInfo.investmentArea = obj.id;
            },
            /*基础货币*/
            getBaseCurrency(obj){
                this.baseInfo.baseCurrency =  obj.id;
            },
            /*投资策略*/
            getSimuCelueId(obj){
                this.baseInfo.simuCelueId = obj.id;
                /*this.list.simuCelueIdList.forEach((el,index,arr) =>{
                    if(el.id == obj.id){
                        this.list.substrategyList = arr[index].sublist;
                        this.msg.substrategy = arr[index].sublist[0].title;
                        this.baseInfo.substrategy = arr[index].sublist[0].id;
                        this.closedSubstrategy();
                        return false;
                    }
                });*/

            },
            closedSimuCelueId(){
                if(typeof this.baseInfo.simuCelueId != "number" ){
                    this.msg.simuCelueIdFlag = true;
                } else {
                    this.msg.simuCelueIdFlag = false;
                }
            },
            /*投资子策略*/
            getSubstrategy(obj){
                this.baseInfo.substrategy = obj.id;
            },
            closedSubstrategy(){
                if(typeof this.baseInfo.substrategy != "number" ){
                    this.msg.substrategyFlag = true;
                } else {
                    this.msg.substrategyFlag = false;
                }
            },
            getPerformanceFeesForm(obj){
                this.baseInfo.performanceFeesForm = obj.id;
            },
            /*添加基金经理*/
            addManger(e){
                e.preventDefault();
                let len = this.managerList.length;
                if(( len && this.managerList[len-1].name!='' && this.managerList[len-1].name!=null )|| len==0){
                    if(len){
                        this.managerList[len-1].readonly = true;
                    }
                    this.deleteSame();
                    if(this.manSelectList.length){
                        let obj = {'name': null, fundDcId:null, readonly: false, managementStartDate:null, managementEndDate:null, id:null};
                        this.managerList.push(obj);
                    }
                }
            },
            /*产品发行类别*/
            getPrdDisCate(obj){
                this.baseInfo.fundPrdType = obj.id;
            },
            closedFundPrdType(){
                if(typeof this.baseInfo.fundPrdType != "number" ){
                    this.msg.fundPrdTypeFlag = true;
                } else {
                    this.msg.fundPrdTypeFlag = false;
                }
            },
            /*选择基金经理*/
            selectedMan(obj){
                if(obj.fundDcId){
                    this.managerList[obj.index].managerCode = obj.fundDcId;
                }
                if(obj.name){
                    this.managerList[obj.index].name = obj.name;
                }
                if(obj.managementStartDate){
                    this.managerList[obj.index].managementStartDate = obj.managementStartDate;
                }
                if(obj.managementEndDate){
                    this.managerList[obj.index].managementEndDate = obj.managementEndDate;
                }
            },
            /*删除基金经理*/
            deleteManager(obj){
                let index = obj.index;
                let item = this.managerList.splice(index, 1);
                this.deleteSame();
            },
            getItem(name){
                let item = '';
                for (let i = 0; i< this.manaList.length; i++){
                    if(name  == this.manaList[i].name){
                        item = this.manaList[i];
                        break;
                    }
                }
                return item;
            },
            closed(){

            },
            showModal(){
                this.$modal.show('submitOk');
            },
            golist(){
                this.$router.push({path: '/fund', query:{item: 2}});
            },
            getTimeFlag(){
                //this.required1  true  三个必填  false  不必填
                // console.log(this.required1) //  true  三个必填
                //console.log(this.required) //  false  两个必填  true  不必填
                if(!this.required1 && this.required){  //两者都不必填的时候
                    return true;
                } else {  //有一个必填   因为都不会为都是必填， 因为做此判断
                    return  (this.required1&& !this.msg.setupDateFlag && !this.msg.registerDateFlag ) || (!this.required && !this.msg.simuRiseBeginDateFlag && !this.msg.simuRiseEndDateFlag)
                }
            },
            investmentScopeError(flag){
                this.msg.investmentScopeFlag = flag;
            },
            goSubmit(e){
                this.getErrFlag();
                this.$refs.investmentScope.validateChild();
                 this.$validator.validateAll().then(result => {
                    let timeFlag =  this.getTimeFlag();
                    if (result && this.allSeleFlag &&  this.msg.investmentScopeFlag && timeFlag && this.msg.prdIssueCompanyCodeFlag){
                        this.beforeCommit();
                        this.$http.request({
                            url: `/product/saveOrUpdateThenAudit`,
                            method: 'post',
                            data: this.baseInfo
                        }, res =>{
                            if(res.data.code == 200){
                                this.isSave = false;
                                this.showModal();
                            }
                        }, err => {
                            this.msgErrText = '服务器繁忙'
                        });
                        return false;
                    }
                });
            },
            goToSave(e){
                e.preventDefault();
                this.beforeCommit();
                if(this.errors.has('registerNumber') || this.msg.registerNumberFlag){
                    this.$store.commit('msg', '备案号重复');
                    return false;
                }
                this.$http.request({
                    url: `/product/saveOrUpdate`,
                    method: 'post',
                    data: this.baseInfo
                }, res =>{
                    if(res.data.code == 200){
                        this.isSave = true;
                        this.showModal();
                    }
                }, err => {
                    this.msgErrText = '服务器繁忙'
                });
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    @import "../../assets/css/common/form";
</style>



// WEBPACK FOOTER //
// src/views/fund/detail.vue